import React, { Component } from 'react';
import { connect } from 'react-redux'
import Grid from '../grid/Grid'
import DeleteButton from '../grid/DeleteButton'
import { deleteAtskaite, reloadAtskaite, loadAtskaites } from '../../actions/atskaiteActions'
import {
    getTextFilterCfg,
    getDateFilterCfg,
    getBadgeFormatterForKodif,
    getSelectFilterCfg,
} from '../grid/ColumnHelpers'
import { getFileHref, fileDownloadPath } from '../forms/FormHelpers'
import { Button } from "reactstrap";

const getColumns = ({ kodif, deleteAct, reloadAtskaite }) => {
    return [
        {
            dataField: 'file_info_filename',
            text: 'Atskaite',
            formatter: (cellContent, row) => {
                return <div className="attach-filename">{getFileHref({ file_id: row.file_info_id, file_sha256: row.file_info_sha_256, filename: row.file_info_filename })}</div>
            },
            filterCfg: getTextFilterCfg()
        },
        {
            dataField: 'statuss',
            text: 'Statuss',
            filterCfg: getSelectFilterCfg(kodif.atskaiteStatuss),
            formatter: (cellContent, row) => getBadgeFormatterForKodif(kodif.atskaiteStatuss)(cellContent),
        },
        {
            dataField: 'atskaites_uzsākšanas_laiks',
            text: 'Uzsākta',
            filterCfg: getDateFilterCfg()
        },
        {
            dataField: 'atskaites_pabeigšanas_laiks',
            text: 'Pabeigta',
            filterCfg: getDateFilterCfg()
        },
        {
            dataField: 'lietotajs_lietotajvards',
            text: 'Lietotājs',
            filterCfg: getTextFilterCfg()
        },
        {
            dataField: 'progress',
            text: 'Progress',
            formatter: (cellContent, row) => {
                const displayedProcessed = row.statuss === 'PABEIGTA'
                    ? row.rindu_skaits
                    : Math.min(row.apstrādāto_rindu_skaits, row.rindu_skaits);
                const progress =
                    ((row.rindu_skaits === 0 && row.apstrādāto_rindu_skaits === 0) || (row.statuss === 'PABEIGTA'))
                    ? 100
                    : Math.min(displayedProcessed / row.rindu_skaits * 100, row.statuss === 'UZSĀKTA' ? 99 : 100);
                return (
                    <div className="text-center" style={{ width: '100%', backgroundColor: '#e0e0e0', borderRadius: '4px' }}>
                        <div
                            style={{
                                width: `${progress}%`,
                                backgroundColor: progress === 100 ? '#4caf50' : '#2196f3',
                                height: '15px',
                                borderRadius: '4px',
                                transition: 'width 0.3s ease-in-out',
                            }}
                        >
                        </div>
                        {`${displayedProcessed}/${row.rindu_skaits}`}
                      </div>
                );
            },
        },
        {
            dataField: 'id',
            sort: false,
            formatter: (cellContent, row) => {
                return (<>
                    {row.statuss === 'PABEIGTA' ?
                    <a className="btn btn-outline-primary btn-sm" href={fileDownloadPath({ file_id: row.file_info_id, file_sha256: row.file_info_sha_256})}><span className="fa fa-download" /> Ielādēt atskaiti</a>
                    : null}
                    <DeleteButton disabled={row.statuss === 'UZSĀKTA'} rowId={row.id} deleteAct={deleteAct} ></DeleteButton>
                    {row.statuss === 'KĻŪDA'
                        ? <Button color="warning" outline size="sm" onClick={() => reloadAtskaite(row.id)}>
                            <i className="fa fa-refresh"></i>
                        </Button>
                        : null}
                </>);
            },
        },
    ]
};


export const getExpandRowDef = ({ kodif }) => ({
    renderer: row => (
        <>
            <table className="table table-sm table-striped">
                <thead>
                    <tr>
                        <th>Parametrs</th>
                        <th>Vērtība</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Atskaites skats</td>
                        <td>{row.kods}</td>
                    </tr>
                    <tr>
                        <td>Perioda sākums</td>
                        <td>{row.gads_no}</td>
                    </tr>
                    <tr>
                        <td>Perioda beigas</td>
                        <td>{row.gads_līdz}</td>
                    </tr>
                </tbody>
            </table>
            {row.statuss === 'KĻŪDA'
                ? <div className="display-linebreak">{row.klūdas_teksts}</div>
                : null}
        </>
    ),
    showExpandColumn: true,
    expandHeaderColumnRenderer: ({ isAnyExpands }) => (isAnyExpands ?
        <i className="fa fa-minus-square expand-collapse-button"></i>
        : <i className="fa fa-plus-square expand-collapse-button"></i>),
    expandColumnRenderer: ({ expanded }) => (expanded ?
        <i className="fa fa-minus-square expand-collapse-button-row"></i>
        : <i className="fa fa-plus-square expand-collapse-button-row"></i>
    )
})


class Atskaites extends Component {
    componentDidMount() {
        // Start polling when the component mounts
        this.pollingInterval = setInterval(this.checkForUzsaktaStatus, 5000); // Check every 5 seconds
    }

    componentWillUnmount() {
        // Clear the interval when the component unmounts
        clearInterval(this.pollingInterval);
    }

    checkForUzsaktaStatus = () => {
        const { list } = this.props.atskaites;
        const hasUzsakta = list.some(row => row.statuss === 'UZSĀKTA');
        if (hasUzsakta) {
            this.props.loadAtskaites(this.props.query);
        }
    };
    
    render() {
        const { loading, list, count } = this.props.atskaites

        if (!this.columns) {
            this.columns = getColumns({
                kodif: this.props.kodif,
                deleteAct: this.props.deleteAct,
                reloadAtskaite: this.props.reloadAtskaite
            })
        }


        if (!this.expandRow) {
            this.expandRow = getExpandRowDef({
                kodif: this.props.kodif,
            })
        }

        return (
            <div className="saraksts-wrapper">
                <Grid
                    loading={loading}
                    dataList={list}
                    totalCount={count}
                    columns={this.columns}
                    rowEvents={this.rowEvents}
                    expandRow={this.expandRow}
                />
            </div>
        )
    }
}

const mapStateToProps = ({ atskaites, kodif, gui, location}) => ({ atskaites, kodif, gui, query: location.query})

export default connect(mapStateToProps,
    {
        loadAtskaites: loadAtskaites,
        reloadAtskaite: reloadAtskaite,
        deleteAct: deleteAtskaite,
    }
)(Atskaites)
